var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"payout-hint-panel panel",class:_vm.panelClass},[(_vm.heading)?_c('div',{staticClass:"panel-heading"},[_vm._t("heading",function(){return [_vm._v(_vm._s(_vm.heading))]})],2):_vm._e(),_c('div',{staticClass:"panel-body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }